// src/components/SuperAdmin/SuperAdminHeader.js
import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { LogOut } from 'lucide-react';

/**
 * Header component displaying greeting, navigation links, and logout icon.
 */
export default function SuperAdminHeader() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const userName = user?.displayName || user?.email || 'Admin';

    const handleLogout = async () => {
        try {
            await logout();
            navigate('/login', { replace: true });
        } catch (err) {
            console.error('Logout failed:', err);
        }
    };

    const activeClass = "text-indigo-600 border-b-2 border-indigo-600";
    const inactiveClass = "text-gray-700 hover:text-indigo-600";

    return (
        <header className="flex items-center justify-between py-4 px-6 bg-white shadow">
            <h1 className="text-2xl font-bold">Hi {userName}</h1>
            <div className="flex items-center space-x-6">
                <nav className="flex space-x-4">
                    <NavLink
                        to="/dashboard"
                        className={({ isActive }) => isActive ? activeClass : inactiveClass}
                    >
                        Dashboard
                    </NavLink>
                    <NavLink
                        to="/project-dashboard"
                        className={({ isActive }) => isActive ? activeClass : inactiveClass}
                    >
                        Projects
                    </NavLink>

                    <NavLink
                        to="/developer-dashboard"
                        className={({ isActive }) => isActive ? activeClass : inactiveClass}
                    >
                        Developers
                    </NavLink>
                    <NavLink
                        to="/brand-details"
                        className={({ isActive }) => isActive ? activeClass : inactiveClass}
                    >
                        Manage Brand
                    </NavLink>
                </nav>
                <button
                    onClick={handleLogout}
                    title="Logout"
                    className="p-2 rounded bg-red-200 hover:bg-red-100"
                >
                    <LogOut className="w-6 h-6 text-red-500 hover:text-red-600" />
                </button>
            </div>
        </header>
    );
}
